import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import iconSizes from "../iconSizes";
import { deprecatedPropValueMessage } from "../../../utils/deprecationUtils";
var isDeprecatedIconSize = function(iconSize) {
    if (typeof iconSize === 'undefined') {
        return false;
    }
    return iconSize === 'xl';
};
var ThreeDimensionalIcon = function(param) {
    var _size = param.size, size = _size === void 0 ? 's' : _size, _color = param.color, color = _color === void 0 ? 'currentColor' : _color, title = param.title;
    if (isDeprecatedIconSize(size)) {
        deprecatedPropValueMessage({
            componentName: 'Icon',
            propName: 'size',
            propValue: 'xl',
            date: 'Q3 2022'
        });
    }
    var ref;
    return _jsxs("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: '0 0 32 32',
        css: {
            width: iconSizes[size],
            height: iconSizes[size],
            fill: color
        },
        role: "img",
        "aria-hidden": (ref = !title) !== null && ref !== void 0 ? ref : false,
        children: [
            title && _jsx("title", {
                children: title
            }),
            _jsx("g", {
                children: _jsx("svg", {
                    viewBox: "0 0 26 24",
                    children: _jsx("path", {
                        d: "M11.226.442a3.528 3.528 0 013.418 0l3.527 1.953a3.528 3.528 0 011.819 3.086v4.827a3.527 3.527 0 01-1.819 3.085l-3.527 1.954a3.528 3.528 0 01-3.418 0l-3.528-1.954a3.528 3.528 0 01-1.819-3.085V5.48c0-1.282.697-2.464 1.819-3.086L11.225.442zm2.278 2.057a1.176 1.176 0 00-1.14 0l-3.19 1.768 3.76 2.256 3.762-2.256-3.192-1.768zm-5.273 7.809V6.444L11.76 8.56v4.394l-2.922-1.618a1.176 1.176 0 01-.606-1.028zm8.8 1.028l-2.92 1.618V8.56l3.527-2.116v3.864c0 .427-.232.821-.606 1.028zm-5.037 6.671a1.176 1.176 0 00-1.726 1.525c-2.276-.05-4.285-.64-5.709-1.525-1.503-.933-2.207-2.08-2.207-3.175 0-.844.462-1.725 1.369-2.531a1.176 1.176 0 00-1.563-1.758C.948 11.618 0 13.09 0 14.833c0 2.197 1.412 3.989 3.32 5.173 1.847 1.147 4.301 1.829 6.951 1.878a1.176 1.176 0 001.822 1.45l1.895-1.778.013-.013c.187-.187.433-.527.433-1.008 0-.48-.246-.82-.433-1.008l-.059-.059-1.948-1.461zm9.38-7.37c.368-.534 1.1-.67 1.635-.3 1.49 1.026 2.431 2.25 2.808 3.594.377 1.35.145 2.676-.446 3.821-1.155 2.238-3.723 3.908-6.411 4.244a1.176 1.176 0 01-.292-2.334c2.015-.252 3.856-1.522 4.613-2.988.364-.707.463-1.423.27-2.11-.193-.69-.721-1.495-1.877-2.291a1.176 1.176 0 01-.3-1.636z",
                        fillRule: "evenodd",
                        clipRule: "evenodd"
                    })
                })
            })
        ]
    });
};
ThreeDimensionalIcon.isCarinaIcon = true;
export default ThreeDimensionalIcon;
